import { render, staticRenderFns } from "./replacementList.vue?vue&type=template&id=776aa0ba&scoped=true"
import script from "./replacementList.vue?vue&type=script&lang=js"
export * from "./replacementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776aa0ba",
  null
  
)

export default component.exports